import { Slide } from '../../../../../../../src/store/models/SearchModels'

export const IMAGE_360_SLIDE: Slide = { id: 1, src: '', alt: '360-image' }
